import {useEffect, useReducer} from "react";

// Один общий setInterval(1s) на все подписанные компоненты вместо отдельного таймера в каждой карточке.
const listeners = new Set();
let timer = null;

const subscribe = (listener) => {
    listeners.add(listener);
    if (timer == null) {
        timer = setInterval(() => listeners.forEach(l => l()), 1000);
    }
    return () => {
        listeners.delete(listener);
        if (listeners.size === 0 && timer != null) {
            clearInterval(timer);
            timer = null;
        }
    };
};

/** Перерисовывает компонент раз в секунду, пока active === true. */
export default function useSecondTicker(active) {
    const [, tick] = useReducer(x => x + 1, 0);
    useEffect(() => {
        if (!active) return undefined;
        return subscribe(tick);
    }, [active]);
}
